import { ConsentManagerProvider } from '@c15t/react';
import type { Callbacks, Script } from 'c15t';
import type { ReactNode } from 'react';

import { buildConsentConfig, type ConsentTranslations } from './consent-config.js';

export type ConsentProviderProps = {
  children: ReactNode;
  translations: ConsentTranslations;
  /** c15t-scripts integrations (e.g. PostHog) — wired by downstream features. */
  extraScripts?: ReadonlyArray<Script>;
  /**
   * c15t lifecycle callbacks. Downstream features hook into `onConsentChanged`
   * to sync third-party SDK opt-in/out on actual consent transitions (not on
   * every page mount / hydration).
   */
  callbacks?: Callbacks;
};

export function ConsentProvider({
  children,
  translations,
  extraScripts = [],
  callbacks,
}: ConsentProviderProps) {
  return (
    <ConsentManagerProvider
      options={buildConsentConfig({ translations, extraScripts, callbacks })}
    >
      {children}
    </ConsentManagerProvider>
  );
}
